import { createSelector } from '@opengov/compose-app/reselect';

import { reportHistorySelector } from './state';

export const selectReportConfigurationHistory = createSelector(reportHistorySelector, (state) => state.history);
